<template>
  <div>
    <header class="header">
      <div class="container header-container">
        <h1 class="header-title">Личный кабинет</h1>
      </div>
    </header>
    <div class="lk">
      <div v-if="user" v-cloak class="container lk-container">
        <div class="lk-profile">
          <div class="lk-profile__background">
            <KeyboardIcon />
          </div>
          <div class="lk-profile__image">
            <UserIcon />
          </div>
          <div class="lk-profile__info">
            <div class="lk-profile__name">
              {{
                (user.first_name[0] ? user.first_name[0] + '. ' : '') +
                (user.patronymic[0] ? user.patronymic[0] + '. ' : '') +
                (user.last_name ? user.last_name : '')
              }}
            </div>
            <div class="lk-profile__type">{{ user.type }}</div>
          </div>
        </div>
        <div class="lk-favorites" v-cloak>
          <div v-show="favorites.length > 0" class="lk-favorites__title">
            Вам понравилось
          </div>
          <div class="lk-favorites__wrap">
            <div
              v-for="favorite in favorites"
              :key="favorite.id"
              class="lk-favorites__item"
              @click="$emit('openArticle', favorite.id)"
            >
              <div class="lk-favorites__image">
                <img
                  v-if="favorite?.poster_url"
                  :src="favorite.poster_url"
                  :alt="favorite.title"
                />
                <BookmarkIcon
                  class="bookmark"
                  @click.stop="
                    () => {
                      removeFavorite(favorite.id);
                    }
                  "
                />
              </div>
              <div class="lk-favorites__info">
                <div class="lk-favorites__title">
                  {{ favorite.description }}
                </div>
              </div>
            </div>
          </div>
          <ObserverBlock @intersect="intersected" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserIcon from '@/components/icons/UserIcon.vue';
import KeyboardIcon from '@/components/icons/KeyboardIcon.vue';
import BookmarkIcon from '@/components/icons/BookmarkIcon.vue';
import { getProfile, getFavorites, unlike } from '@/functions/API';
import ObserverBlock from '@/components/blocks/observer/ObserverBlock.vue';

export default {
  name: 'LkPage',
  components: {
    UserIcon,
    KeyboardIcon,
    BookmarkIcon,
    ObserverBlock,
  },
  data() {
    return {
      user: null,
      favorites: [],
      page: 0,
      endContent: false,
    };
  },
  mounted() {
    this.getUser();
  },
  methods: {
    getUser() {
      getProfile((res) => {
        if (res !== false) {
          this.user = res || null;
        }
      });
    },
    getFavorites() {
      getFavorites(this.page, (res) => {
        if (res !== false) {
          if (res?.length > 0) {
            if (this.favorites.length > 0) {
              this.favorites = this.favorites.concat(res);
            } else {
              this.favorites = res;
            }
          } else {
            this.endContent = true;
          }
        }
      });
    },
    removeFavorite(id) {
      const _id = id;
      unlike(_id, (res) => {
        if (res !== false) {
          this.favorites = [
            ...this.favorites.filter((favorite) => favorite.id !== _id),
          ];
        }
      });
    },
    intersected() {
      if (!this.endContent) {
        this.page += 1;
        this.getFavorites();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  background-color: var(--color-white);
  color: var(--color-black);

  &-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 12px;
    position: relative;
    display: flex;
    padding-top: 16px;
    padding-bottom: 16px;
  }
  &-title {
    color: var(--color-black);
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 125%;
  }
}
.lk {
  margin-top: 16px;
  margin-bottom: 16px;

  &-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  &-profile {
    background-color: var(--color-blue);
    overflow: hidden;
    border-radius: 16px;
    position: relative;
    &__background {
      color: var(--color-white);
      opacity: 0.16;
      position: absolute;
      right: 0;
      top: 0;
      svg {
        width: 99px;
        height: 99px;
        min-width: 99px;
        min-height: 99px;
      }
    }
    &__image {
      padding: 20px;
      color: #ffffff;
      img {
        width: 64px;
        height: 64px;
        min-width: 64px;
        min-height: 64px;
        object-fit: cover;
        overflow: hidden;
        border-radius: 50%;
      }
    }
    &__info {
      display: flex;
      flex-direction: column;
      gap: 6px;
      padding: 20px;
    }
    &__name {
      color: #ffffff;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 125%;
    }
    &__type {
      color: #ffffff;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 125%;
      opacity: 0.64;
    }
  }
  &-favorites {
    &__wrap {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-top: 12px;
      margin-bottom: 60px;
    }
    &__item {
      width: 100%;
      overflow: hidden;
      position: relative;
      border-radius: 12px;
      cursor: pointer;
    }
    &__image {
      width: 100%;
      height: calc((100vw - 32px) / 16 * 9);
      max-height: 315px;
      z-index: 0;
      display: flex;
      position: relative;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 14px;
        background-color: var(--color-gray);
      }
      .bookmark {
        position: absolute;
        top: 16px;
        right: 16px;
        color: var(--color-white);
        opacity: 0.8;
        cursor: pointer;
        svg {
          width: 16px;
          height: 16px;
          min-width: 16px;
          min-height: 16px;
        }
      }
    }
    &__info {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      padding: 16px;
      background-color: var(--color-white-opacity);
    }
    &__title {
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 16px;
      color: var(--color-black);
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &__author {
      color: var(--color-gray);
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 125%;
    }
    .swiper {
      overflow: visible;
      max-width: 80%;
      margin-left: 0;
    }
  }
}
</style>
